// extracted by mini-css-extract-plugin
export default {"root":"B39q9_gGnE","image":"ibasM5gSmD","focalPoint":"CFNE2qOeqR"};